import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  UserAPIRawRequestBodyType,
  UserAPIRequestBodyType
} from './api-request-body';

export type UserAPIRawSuccessResponseType = {
  id: number;
  username: string; // [1..20] character
  email: string; // [1..254] characters
  is_active: boolean;
  my_project_count: number;
  approved_project_count: number;
  can_be_deleted: boolean;
  created_at: string;
  updated_at: string;
};

export type UserAPIRawValidationErrorType = APIRawValidationErrorType<
  UserAPIRawRequestBodyType
>;

export type UserAPIValidationErrorType = APIValidationErrorType<
  UserAPIRequestBodyType
>;

export type IUserAPIValidationErrorType = IAPIValidationErrorType<
  UserAPIRequestBodyType
>;

export const IUserAPIValidationErrorFactory = IRecord<
  UserAPIValidationErrorType
>({
  name: IList<string>(),
  email: IList<string>(),
  password: IList<string>(),
  isActive: IList<string>()
});
